export default {
    all(id, axios) {
        return axios({
            url: `patients/${id}/remarks`,
            method: 'GET'
        })
    },
    add(id, remarkData, axios) {
        return axios({
            url: `patients/${id}/addRemark`,
            method: 'POST',
            data: remarkData
        })
    },
    edit(id, remarkId, remarkData, axios) {
        return axios({
            url: `patients/${id}/remarks/${remarkId}/edit`,
            method: 'POST',
            data: remarkData
        })
    },
    delete(id, remarkId, remarkData, axios) {
        return axios({
            url: `patients/${id}/remarks/${remarkId}/delete`,
            method: 'DELETE'
        })
    }
}
